import services from "../../data/WebDevSerivce-Texas.json";

export default function Section14() {
    return (
        <div className="w-full bg-[white] SectionWebDevServices py-[30px] md:py-[50px]">
            {/* Section Heading */}
            <div className="text-center w-[90%] md:w-[65%] mx-auto mb-[40px]">
                <h2 className="text-[26px] md:text-[30px] font-bold text-[#151515] leading-[36px] md:leading-[46px] mb-2">
                   Texas-Focused Core  <span className="text-[#DA2128]">Web Development Services</span>
                </h2>
                
                
            </div>

            {/* Cards Grid */}
            <div className="flex justify-center flex-wrap gap-[25px] w-[85%] mx-auto">
                {services.map((service, index) => (
                    <div
                        key={index}
                        className={`${index % 2 === 0
                            ? "bg-[#E42E35] text-white"
                            : "bg-[#f5f5f5] text-[#373737]"
                            } w-[90%] sm:w-[46%] xl:w-[30%] p-[4%] md:p-[2%] rounded-2xl shadow-md text-left`} // added text-left
                    >
                        <h3 className="text-[20px] md:text-[22px] font-bold mb-3 leading-[28px]">
                            {service.title}
                        </h3>
                        <p className="text-[13px] md:text-[14px] mb-4">{service.description}</p>
                        <ul className="list-disc ml-5 space-y-2">
                            {service.points.map((point, i) => (
                                <li key={i} className="text-[13px] md:text-[14px] leading-[22px]">
                                    {point}
                                </li>
                            ))}
                        </ul>
                    </div>
                ))}
            </div>

            {/* CTA
            <div className="text-center mt-12">
                <a
                    href="https://mean3.com/contact-mean3"
                    className="bg-[#DA2128] hover:bg-[#b71c22] text-white px-8 py-3 rounded-lg font-semibold text-[15px] md:text-[16px] transition-all duration-300 inline-block text-center"
                >
                    Explore All Services
                </a>

            </div> */}

            {/* Divider Line */}
            <div className="line mb-[55px] mt-[4%] mx-auto w-[70%] md:w-[61%] shadow-line h-2 rounded-[100%]"></div>
        </div>
    );
}
